import { Accordion, Select, Tooltip } from '@cimpress/react-components';
import React, { PureComponent } from 'react';
import Engraving from './engraving';
import MapPoints from '../../documents/transforms/mapPoints';
import ColorProfile from './colorProfile';
import {
    EFFECT_TYPE_LIST,
    ENGRAVING_CHANNEL,
    LETTERPRESS_CHANNEL,
    LETTERPRESS_DEPTHS,
    LETTERPRESS_MODE_SOFTLIGHT,
    LETTERPRESS_MODES_OPTIONS,
} from 'src/config/constants';

interface SelectEvent {
    value: string | number;
}

interface Props {
    id: string;
    isEngraving: boolean;
    colorEngraving: string;
    changeEngravingColor: (data: { id: string; color: string }) => void;
    changeProfileColor: (data: { id: string; colorProfile: string }) => void;
    colorProfile?: string;
    letterPress?: { mode: string; depth: number };
    setEffect: (data: { id: string; effectType: string }) => void;
    changeLetterPressMode: (data: { id: string; mode: string }) => void;
    changeLetterPressDepth: (data: { id: string; depth: number }) => void;
}

interface State {
    isOpen: boolean;
}

export default class AdvancedView extends PureComponent<Props, State> {
    state: State = {
        isOpen: false,
    };

    handleClick = (_: any, isOpen: boolean) => {
        this.setState({ isOpen });
    };

    render() {
        const {
            id,
            isEngraving,
            changeEngravingColor,
            changeProfileColor,
            colorEngraving,
            colorProfile,
            letterPress,
            setEffect,
            changeLetterPressMode,
            changeLetterPressDepth,
        } = this.props;

        const valueLetterPressMode = {
            value: letterPress?.mode,
            label: letterPress?.mode === LETTERPRESS_MODE_SOFTLIGHT ? 'Softlight' : 'Overlay',
        };
        const effectType = letterPress ? LETTERPRESS_CHANNEL : isEngraving ? ENGRAVING_CHANNEL : 'none';

        const effectTypeValue = EFFECT_TYPE_LIST.find((opt) => opt.value === effectType) || EFFECT_TYPE_LIST[0];

        return (
            <div className='advanced__tools'>
                <Accordion
                    variant='minimal'
                    title={this.state.isOpen ? 'Hide Advanced' : 'Show Advanced'}
                    className='advanced__tools__content'
                    onHeaderClick={this.handleClick}>
                    <h3>Color Properties</h3>
                    <ColorProfile
                        activeProfile={colorProfile}
                        onSelect={(e) => changeProfileColor({ id, colorProfile: e.value })}
                    />
                    <h3>Position</h3>
                    <MapPoints id={id} />
                    <h3>Effects</h3>
                    <div className='effect-type-selector'>
                        <Select
                            label='Effect Type'
                            value={effectTypeValue}
                            className='effect-type-select'
                            data-testid='effect-type-selector'
                            options={EFFECT_TYPE_LIST}
                            onChange={(e: SelectEvent) => setEffect({ id, effectType: e.value as string })}
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>
                    {effectType === ENGRAVING_CHANNEL && (
                        <Engraving
                            id={id}
                            isEngraving={isEngraving}
                            changeEngravingColor={changeEngravingColor}
                            colorEngraving={colorEngraving}
                        />
                    )}
                    {effectType === LETTERPRESS_CHANNEL && letterPress && (
                        <div className='letterpress-settings'>
                            <h3>
                                Letter Press Settings{' '}
                                <Tooltip
                                    contents='Letter Press is a printing technique that creates a debossed effect on the paper. It
                                involves pressing an inked plate onto the paper, resulting in a tactile and visually
                                appealing design. This technique is often used for wedding invitations, business cards,
                                and other high-end printed materials.'>
                                    <img
                                        src='https://static.ux.cimpress.io/assets/icons/help-circle-f.svg'
                                        alt='Help about Letter Press'
                                    />
                                </Tooltip>
                            </h3>
                            <Select
                                label='Choose Mode'
                                value={valueLetterPressMode}
                                className='letterpress-mode-select'
                                options={LETTERPRESS_MODES_OPTIONS}
                                onChange={(e: SelectEvent) => changeLetterPressMode({ id, mode: e.value as string })}
                                isClearable={false}
                                isSearchable={false}
                            />
                            <Select
                                label='Choose Depth'
                                value={{ value: letterPress.depth, label: `${letterPress.depth}` }}
                                className='letterpress-depth-select'
                                options={LETTERPRESS_DEPTHS}
                                onChange={(e: SelectEvent) => changeLetterPressDepth({ id, depth: e.value as number })}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    )}
                </Accordion>
            </div>
        );
    }
}
